import * as fromStore from '../actions/settings.action';
import {Store} from '../../store';
import {Timing} from '../../timing';

export interface SettingsState {
  timings: Timing[];
  store: Store;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  timings: null,
  loading: false,
  store: null,
  loaded: true,
  error: null,
};

export function reducer(state = initialState, action: fromStore.SettingsAction): SettingsState {
  switch (action.type) {
    case fromStore.GET_STORE_TIMINGS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStore.GET_STORE_TIMINGS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        timings: action.payload,
        error: null
      };
    }
    case fromStore.GET_STORE_TIMINGS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };
    }

    case fromStore.ADD_NEW_TIMING: {
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    }
    case fromStore.ADD_NEW_TIMING_SUCCESS: {
      return {
        ...state,
        timings: action.payload,
        loaded: true,
        loading: false,
        error: null
      };
    }

    case fromStore.ADD_NEW_TIMING_ERROR: {
      return {
        ...state,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }

    case fromStore.GET_STORE_DETAILS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStore.GET_STORE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        store: action.payload,
        error: null
      };
    }
    case fromStore.GET_STORE_DETAILS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };
    }

    case fromStore.UPDATE_STORE_TIMIMGS_SUCCESS: {
      return {
        ...state,
        timings: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStore.UPDATE_STORE_TIMINGS: {
      return {
        ...state,
        timings: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromStore.UPDATE_STORE_TIMINGS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }

    case fromStore.UPDATE_STORE_DETAILS_SUCCESS: {
      return {
        ...state,
        store: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStore.UPDATE_STORE_DETAILS: {
      return {
        ...state,
        store: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromStore.UPDATE_STORE_DETAILS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }

  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/reducers/settings.reducer.ts